import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function queryList(data){
  return request({
    url:applicationName+'/admin/optlogger/list',
    method:'get',
    params:data
  })
}